import { Modal } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

function RejectionModal({ open, onClose, onReject, title }) {
  const [reason, setReason] = useState("");
  const [showError, setShowError] = useState(false);

  const handleReject = () => {
    if (!reason) {
      setShowError(true);
      return;
    }
    setReason("");
    onReject(reason);
  };

  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      aria-labelledby="rejection-success-modal"
      aria-describedby="rejection-success-modal"
    >
      <div className="modal_container column">
        <p className="text_center">{title ?? "Reason for Rejection"}</p>
        <div className="column shrink">
          <input
            type="text"
            className="input"
            placeholder="Enter Reason for Rejection"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <span className="gray sm ">{showError && "Please enter a reason for rejection."}</span>
        </div>
        <div className="row center">
          <button className="btn ghost_outline_btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn reject" onClick={handleReject}>
            Reject
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}

export default RejectionModal;
